export const PRIVATE_PERSON = 'private_person'
